// @module C3.ShoppingExtensions.System8Page
define('C3.ShoppingExtensions.MeetTeam.Cell.View'
,	[
	    'c3_shoppingextensions_meetourteam_cell.tpl'
	,	'SCView'
	,   'GlobalViews.Breadcrumb.View'
   ,   'C3.ShoppingExtensions.MeetTeam.Bio.View'
	,   'Utils'

    ]
, function (
	    c3_shoppingextensions_meetourteam_cell_tpl
	,	SCViewModule
	,   GlobalViewsBreadcrumbView
   ,   BioPopupView
	,   Utils
)
{
    'use strict';

     var SCView = SCViewModule.SCView;

     function MeetTeamCellView (options) {
     	SCView.call(this, options);

     	  this.template = c3_shoppingextensions_meetourteam_cell_tpl;
        this.options = options;
		  this.model = options.model;
		  this.application = options.application;
        this.layout = options.layout;

        this.showBio = function showBio(el){

            var target = el.currentTarget

            var popup = new BioPopupView({
               application : this.application,
               name : this.model.get('empname'),
               title : this.model.get('emptitle'),
               empImg : this.model.get('empimgurl'),
               empBio : this.model.get('empbio')
           })

           if (popup)
           this.layout.showContent(popup, {showInModal: true});
        }
     }

     MeetTeamCellView.prototype = Object.create(SCView.prototype);
     MeetTeamCellView.prototype.constructor = MeetTeamCellView;

     MeetTeamCellView.prototype.getChildViews = function (){
     	return {
     		
     	}
     }

     MeetTeamCellView.prototype.getEvents = function() {
            return {
                'click [data-action="show-bio-in-modal"]':'showBio'
            };
        }

     MeetTeamCellView.prototype.render = function () {
    	SCView.prototype.render.call(this);
    	
    }

    MeetTeamCellView.prototype.getContext = function () {
    	return {
    		name : this.model.get('empname'),
         title : this.model.get('emptitle'),
         empImg : this.model.get('empimgurl'),
         empBio : this.model.get('empbio')		
    	}
    }

     return MeetTeamCellView;
});
